import React, { Component } from 'react';
import './App.css';

export default class ComponentFavorite extends Component {

  // Properties used by this component:
  // userId, drinkID, arraytest

  constructor(props) {
    super(props);
    
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate() {
  }

  componentWillReceiveProps(nextProps) {
  }

  render() {
    const value_userID = this.props.userId;
    
    const style_elUserID = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    let transformPropValue_drinkID = (input) => {
      // This function modifies the value for property 'text'.
      // There is a variable named 'input' that provides the property value.
      //
      console.log(input);
      return input;
    }
    
    const value_drinkID = transformPropValue_drinkID(this.props.drinkID);
    
    const style_elDrinkID = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    let transformPropValue_arraytest = (input) => {
      // This function modifies the value for property 'text'.
      // There is a variable named 'input' that provides the property value.
      //
      if (input !== undefined && input.split != null ){
          let tempArr=input.split(',');
      	console.log("test "+tempArr);
          }
      
      return input;
    }
    
    const value_arraytest = transformPropValue_arraytest(this.props.arraytest);
    
    const style_elArraytest = {
      color: 'rgba(0, 0, 0, 0.8500)',
      textAlign: 'left',
     };
    
    return (
      <div className="ComponentFavorite appBg">
        <div className="layoutFlow">
          <div className="elUserID">
            <div className="baseFont" style={style_elUserID}>
              <div>{value_userID !== undefined ? value_userID : (<span className="propValueMissing">{this.props.locStrings.componentfavorite_text_772386}</span>)}</div>
            </div>
          </div>
          
          <div className="elDrinkID">
            <div className="baseFont" style={style_elDrinkID}>
              <div>{value_drinkID !== undefined ? value_drinkID : (<span className="propValueMissing">{this.props.locStrings.componentfavorite_textcopy_45392}</span>)}</div>
            </div>
          </div>
          
          <div className="elArraytest">
            <div className="baseFont" style={style_elArraytest}>
              <div>{value_arraytest !== undefined ? value_arraytest : (<span className="propValueMissing">{this.props.locStrings.componentfavorite_textcopy2_704009}</span>)}</div>
            </div>
          </div>
        </div>
        
      </div>
    )
  }
  
}
